<ng-container *ngIf="render$ | async" />

<div id="fasteners-form" class="flex flex-auto flex-row justify-start items-stretch gap-4 h-full">
  <div class="basis-[42%] custom-hole-list-wrapper h-full" cslPerfectScrollbar>
    <csl-custom-fasteners
      [editable]="editable"
      (selectedHoleChange)="onSelectedCustomHole($event)"
      (selectedFastenersSetChange)="onSelectedFastenersSet($event)"
      [selectedHole]="selectedCustomFastener"
      [selectedFastenersSet]="selectedFastenersSet"
      [mainMaterialThickness]="mainMaterialThickness"
      [panel]="panel"
      (formChanged)="customFastenersChange($event)"></csl-custom-fasteners>
  </div>

  <div class="flex flex-1 flex-col justify-start items-start" cslPerfectScrollbar>
    <csl-svg-workspace
      #svgWorkspace
      class="panel-schema"
      [p]="panel"
      [selectableHoles]="true"
      [highlightedHole]="selectedCustomFastener"
      (highlightedHoleChange)="onSelectedCustomHole($event)"
      (highlightedFastenersSetChange)="onSelectedFastenersSet($event)"
      [highlightedFastenersSet]="selectedFastenersSet">
    </csl-svg-workspace>
  </div>
</div>
